import { createClient, type SupabaseClient } from "@supabase/supabase-js";

export type { Session, User as SupabaseAuthUser } from "@supabase/supabase-js";
export type LawnOpsSupabaseClient = SupabaseClient;

export interface SupabaseConfig {
  url: string;
  anonKey: string;
}

export interface CreateClientArgs {
  url: string | undefined;
  anonKey: string | undefined;
}

/**
 * Build a Supabase client when configured; return `null` when not.
 *
 * The Supabase remote project is deferred (see CLOUD_SETUP.md). Until it's
 * provisioned, web preview deploys ship with placeholder env vars and we
 * detect that here rather than crashing the app at boot.
 */
export function createLawnOpsClient({
  url,
  anonKey,
}: CreateClientArgs): LawnOpsSupabaseClient | null {
  if (!isUsableConfig(url, anonKey)) return null;
  return createClient(url as string, anonKey as string, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

export function isUsableConfig(url: string | undefined, anonKey: string | undefined): boolean {
  if (!url || !anonKey) return false;
  // The Vite env.example placeholder is a clear sentinel.
  if (url.includes("YOUR-PROJECT-REF")) return false;
  if (anonKey.startsWith("eyJhbGciOi...") || anonKey.length < 40) return false;
  return true;
}

export { createClient as createSupabaseClientRaw };
